export const FAQConstants = {
  tag: "General FAQ's",
  title: "Your Questions, Simplified Here",
  viewAllText: "View All",
  faqItems: [
    {
      question: "What is CricCenter?",
      answer:
        "CricCenter is an all-in-one digital cricket platform that helps players, scorers, organisers, leagues, & associations manage matches, tournaments, live scoring, statistics, and fan engagement, seamlessly and in real time.",
    },
    {
      question: "Who can use CricCenter?",
      answer:
        "CricCenter is designed for anyone involved in cricket, from casual players to professional leagues and associations. Whether you are organizing a local tournament or managing a national league, our platform adapts to your needs.",
    },
    {
      question: "Is CricCenter available on mobile and web?",
      answer:
        "Yes! CricCenter is available as both a web application and mobile apps for iOS and Android, ensuring you can manage your cricket activities on the go or from your desktop.",
    },
    {
      question: "Is CricCenter free to use?",
      answer:
        "CricCenter offers both free and premium plans. You can start for free to explore features, and upgrade to a paid plan when you're ready for advanced functionality and additional features.",
    },
    {
      question: "How do I get started with CricCenter?",
      answer:
        "Simply sign up on our website or download our mobile app. You can create a free account and start exploring immediately. No credit card required to begin!",
    },
  ],
};
